module.exports = __webpack_public_path__ + "img/40_69_003_870.3a4b48bb.jpg";